import React from "react";

import { PriceWithGeedeeContent } from "../price-with-geedee/PriceWithGeedeeContent";
import { PriceWithoutGeedeeContent } from "../price-without-geedee/PriceWithoutGeedeeContent";
import { PriceWithGeedeeDetails, PriceWithoutGeedeeDetails, TooltipType } from "../shared/types";

export const GeedeeTooltipContent = ({
  type,
  priceWithGeedeeDetails,
  priceWithoutGeedeeDetails,
}: {
  type: TooltipType;
  priceWithGeedeeDetails?: PriceWithGeedeeDetails | null;
  priceWithoutGeedeeDetails?: PriceWithoutGeedeeDetails | null;
}) => {
  if (type === "with_geedee") return <PriceWithGeedeeContent details={priceWithGeedeeDetails} />;

  return <PriceWithoutGeedeeContent details={priceWithoutGeedeeDetails} />;
};
